(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bs-article"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var body = document.querySelector('[data-bs-art-body]');
    var toc = document.querySelector('[data-bs-toc]');
    if (body) {
      /* Older posts repeat the title as an H1 in the body; it is shown as H2 now, and dropped when it duplicates the title. */
      var titleEl = document.querySelector('.bs-art-title');
      var tt = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
      document.querySelectorAll('[data-bs-art-body] h2[data-bs-was-h1]').forEach(function(h){
        if (tt && h.textContent.replace(/\s+/g, ' ').trim().toLowerCase() === tt) h.remove();
      });
    }
    if (!body || !toc) return;
    var hs = document.querySelectorAll('[data-bs-art-body] h2');
    if (hs.length < 3) return;
    var ol = toc.querySelector('ol');
    var used = {};
    hs.forEach(function(h, i){
      var text = h.textContent.trim();
      if (!text) return;
      var id = h.id || text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || ('section-' + i);
      while (used[id]) id += '-' + i;
      used[id] = true; h.id = id;
      var li = document.createElement('li'), a = document.createElement('a');
      a.href = '#' + id; a.textContent = text; li.appendChild(a); ol.appendChild(li);
    });
    toc.hidden = false;
    if (window.matchMedia('(min-width: 750px)').matches) toc.open = true;
  })();
  /* Recipe cards: switch batch size (amounts scale linearly from data-base) and print just the card. */
  (function(){
    var cards = document.querySelectorAll('[data-bs-recipe]');
    if (!cards.length) return;
    var U = { lb: { m: 'kg', f: 0.45359237, d: 2, md: 2 }, oz: { m: 'g', f: 28.3495, d: 2, md: 0 }, gal: { m: 'L', f: 3.78541, d: 2, md: 1 }, g: { d: 1 }, tsp: { d: 2 }, pkg: { d: 1 }, cups: { m: 'mL', f: 236.6, d: 2, md: 0 }, tasses: { m: 'mL', f: 236.6, d: 2, md: 0 }, tbsp: { d: 1 }, 'c. à s.': { d: 1 }, mL: { d: 0 } }; // cups/tbsp/mL: kombucha recipe cards (8 Oct 2026)
    function fmt(n, d) { var p = Math.pow(10, d), r = Math.round(n * p) / p; var t = String(r); return (document.documentElement.lang || '').indexOf('fr') === 0 ? t.replace('.', ',') : t; }
    cards.forEach(function(card){
      var base = parseFloat(card.getAttribute('data-base') || '5');
      function apply(size){
        var k = size / base;
        card.querySelectorAll('[data-amt]').forEach(function(el){
          var a = parseFloat(el.getAttribute('data-amt')) * k, u = el.getAttribute('data-unit') || '', m = U[u] || { d: 2 };
          var t = fmt(a, m.d) + (u ? ' ' + u : '');
          if (m.m) t += ' (' + fmt(a * m.f, m.md) + ' ' + m.m + ')';
          el.textContent = t;
        });
        card.querySelectorAll('[data-size-label]').forEach(function(el){ el.textContent = size + ' gal'; });
        card.querySelectorAll('.bs-recipe-size').forEach(function(b){ b.setAttribute('aria-pressed', String(parseFloat(b.getAttribute('data-size')) === size)); });
      }
      card.querySelectorAll('.bs-recipe-size').forEach(function(b){ b.addEventListener('click', function(){ apply(parseFloat(b.getAttribute('data-size'))); }); });
      var p = card.querySelector('[data-bs-recipe-print]');
      if (p) p.addEventListener('click', function(){
        // Print only this card: copy it into a print-only root at the top level of <body>, hide everything else.
        var old = document.getElementById('bs-recipe-print-root'); if (old) old.remove();
        var root = document.createElement('div'); root.id = 'bs-recipe-print-root';
        var sec = document.createElement('div'); sec.className = 'bs-section';
        var body = document.createElement('div'); body.className = 'bs-art-body';
        body.appendChild(card.cloneNode(true)); sec.appendChild(body); root.appendChild(sec); document.body.appendChild(root);
        // Shopify serves section {% stylesheet %} CSS with media="screen", so copy the recipe rules into a style that also applies to print.
        var css = '';
        for (var i = 0; i < document.styleSheets.length; i++) {
          var sh = document.styleSheets[i];
          try { for (var j = 0; j < sh.cssRules.length; j++) { var rt = sh.cssRules[j].cssText; if (rt.indexOf('bs-recipe') > -1) css += rt + '\n'; } } catch (e) {}
        }
        var st = document.getElementById('bs-recipe-print-style'); if (st) st.remove();
        st = document.createElement('style'); st.id = 'bs-recipe-print-style'; st.textContent = css; document.head.appendChild(st);
        var html = document.documentElement, done = false;
        function cleanup(){ if (done) return; done = true; html.classList.remove('bs-print-recipe'); root.remove(); st.remove(); window.removeEventListener('afterprint', cleanup); }
        html.classList.add('bs-print-recipe');
        window.addEventListener('afterprint', cleanup);
        window.print();
        setTimeout(cleanup, 60000); // fallback only; the root is invisible on screen
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bs-learn-topic"] && !Shopify.designMode) return;
  try {
    
  (function(){
    if (window.bsLearnVideos) return; window.bsLearnVideos = true;
    document.addEventListener('click', function(e){
      var b = e.target.closest('.bs-learn-play'); if (!b) return;
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(b.dataset.yt) + '?autoplay=1&rel=0&modestbranding=1';
      f.title = (b.getAttribute('aria-label') || 'Video').replace('Play video: ', '');
      f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      f.allowFullscreen = true;
      f.referrerPolicy = 'strict-origin-when-cross-origin';
      b.replaceWith(f);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bs-product-video"] && !Shopify.designMode) return;
  try {
    
  (function(){
    if (window.bsProductVideos) return; window.bsProductVideos = true;
    document.addEventListener('click', function(e){
      var b = e.target.closest('.bs-pv__play'); if (!b) return;
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(b.dataset.yt) + '?autoplay=1&rel=0&modestbranding=1';
      f.title = (b.getAttribute('aria-label') || 'Video').replace('Play video: ', '');
      f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      f.allowFullscreen = true;
      f.referrerPolicy = 'strict-origin-when-cross-origin';
      b.replaceWith(f);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
